/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Theme_DescInputs */



/**
* | output |
* | --- |
* | "Automatic follows your device's setting." |
*
* @param {Settings_Theme_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_theme_desc = /** @type {((inputs?: Settings_Theme_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Automatisch volgt de instelling van je toestel.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Automatique suit le réglage de votre appareil.")
	return /** @type {LocalizedString} */ ("Automatic follows your device's setting.")
});